// Import: Middleware Action & Custom Types
import {
    CLEAN_GET_SALES_MONTHLY,
    CLEAN_GET_SALES_MONTHLY_ERROR,
} from "_models/redux/types";

// Action function
export const cleanGetSalesMonthlyAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            payload: undefined,
            type: CLEAN_GET_SALES_MONTHLY,
        });
    } catch (e) {
        dispatch({
            payload: undefined,
            type: CLEAN_GET_SALES_MONTHLY_ERROR,
        });
    }
};
